function ScrollDown() {
	return (
		<div className="scroll-down">
			<a href="#about" className="mouse-wrapper">
				<span>Scroll Down</span>
				<span className="mouse">
					<span className="wheel" />
				</span>
			</a>
		</div>
	);
}

export default ScrollDown;
